export const androidApp = {
  label: "Get the Android App",
  storeName: "Google Play",
  url: "https://play.google.com/store/apps/details?id=io.recettes&pcampaignid=web_share",
};

export const appStoreLinks = {
  android: androidApp,
  ios: null,
};